import FundraisingEventQuickLinks from './FundraisingEventQuickLinks'

export default FundraisingEventQuickLinks
